export const statusLabelMap: Record<string, string> = {
  "0": "Beklemede",
  "1": "Gönderildi",
  "2": "Onaylandı",
  "3": "İptal Edildi",
  "4": "Tamamlandı",
};

// İzolasyon için özel status seçenekleri (ByzFilterCard için)
export const isolationStatusOptions = [
  { label: "Beklemede", value: "0" },
  { label: "Gönderildi", value: "1" },
  { label: "Onaylandı", value: "2" },
  { label: "İptal Edildi", value: "3" },
  { label: "Tamamlandı", value: "4" },
];